import {styled} from '@mui/material'

export const EmptyPlaceholderSummaryCardStyle = styled('div')(({theme}) => ({
  border: '1px solid lightgray',
  borderRadius: '8px',
  width: '100%',
  padding: '24px',
  height: '214px'
}))
